import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Parametre } from '../models/parametre.model';
import { ParametreService } from '../services/parametre.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  parametres: Parametre | null = null;

  constructor(
    private parametreService: ParametreService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.parametreService.getParametres().subscribe(data => {
      this.parametres = data;
    });
  }

  get urlCarteContact(): SafeResourceUrl {
    const adresse = encodeURIComponent(this.parametres?.adresse || 'Théâtre de Sidi Dhaher, Sousse, Tunisie');
    return this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.google.com/maps?q=${adresse}&output=embed`);
  }
}
